
import Dropzone from '@/components/library/Dropzone.vue';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { computed, defineComponent } from 'vue';
import BlockingLoader from './components/BlockingLoader.vue';
import { init as initKeyboardService } from './services/keyboard-service';

interface DataBit {
  deferredPrompt?: any | null;
}

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    BlockingLoader,
    Dropzone,
  },
  provide() {
    return {
      deferredPrompt: computed(() => this.deferredPrompt),
    };
  },
  data() {
    return {
      deferredPrompt: null,
    } as DataBit;
  },
  async mounted() {
    if (this.$route.path === '/login' && this.$route.query.loggedOut) {
      await this.$store.dispatch('logoutUser');
    }
    this.$store.dispatch('bootApp');
  },
  async updated() {
    if (this.$route.path === '/login' && this.$route.query.loggedOut) {
      await this.$store.dispatch('logoutUser');
    }
  },
  created() {
    initKeyboardService();
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      this.deferredPrompt = e;
    });
  },
  methods: {
    async install() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
      }
    },
  },
});
